import React from "react";
import { useSelector } from "react-redux";
import {
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
} from "@material-ui/icons";
import { Grid, Box } from "@material-ui/core";

import useStyles from "./accountStyles";
import { UserLetterAvatar } from "../../utils";
import translate from "../../../i18n/translate";
import { SrInput, SrLabel, Typography } from "../../common";

const PersonalInfo = () => {
  const classes = useStyles();
  const { user } = useSelector(({ auth }) => auth);
  const userAvatar = useSelector(({ auth }) => auth.avatar);

  return user ? (
    <form>
      <Grid container spacing={3}>
        <Grid item xs={12} md={4} container alignItems="center">
          <SrLabel>{translate("common.profilePic")}</SrLabel>
        </Grid>
        <Grid item xs={12} md={8}>
          <UserLetterAvatar
            firstName={user.first_name}
            lastName={user.last_name}
            avatarImage={userAvatar}
            large
          />
        </Grid>
        <Grid item sm={12} md={4} container alignItems="center">
          <SrLabel name="firstName">{translate("common.name")}</SrLabel>
        </Grid>
        <Grid item xs={12} md={4}>
          <SrInput
            name="firstName"
            value={user.first_name}
            disabled
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <SrInput name="lastName" value={user.last_name} disabled fullWidth />
        </Grid>
        <Grid item xs={12} md={4} container alignItems="center">
          <SrLabel name="email">{translate("common.email")}</SrLabel>
        </Grid>
        <Grid item xs={12} md={4}>
          <SrInput name="email" value={user.email} disabled fullWidth />
        </Grid>
        {user.verifiedEmail ? (
          <Grid
            item
            xs={12}
            md={4}
            container
            className={classes.statusVerified}
            alignItems="center"
          >
            <Box mr={1} display="flex" alignItems="center">
              <CheckCircleIcon className={classes.statusVerified} />
            </Box>
            <Typography>{translate("common.verified")}</Typography>
          </Grid>
        ) : (
          <Grid
            item
            xs={12}
            md={4}
            container
            className={classes.statusUnverified}
            alignItems="center"
          >
            <Box mr={1} display="flex" alignItems="center">
              <CancelIcon className={classes.statusUnverified} />
            </Box>
            <Typography>{translate("common.unverified")}</Typography>
          </Grid>
        )}
      </Grid>
    </form>
  ) : (
    <Typography>{translate("account.userNotFound")}</Typography>
  );
};

export default PersonalInfo;
